import { render } from "./AddNormativeDocumentType.vue?vue&type=template&id=48ef88b1"
import script from "./AddNormativeDocumentType.vue?vue&type=script&lang=js"
export * from "./AddNormativeDocumentType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__